export default __webpack_public_path__ + "static/media/higher_brand_arrow_right.a728aee0.svg";